module.exports = __webpack_public_path__ + "static/media/jeffreyHeadshot.805e6783.png";